import { CircularProgress } from "@mui/material";
import AlertDialog from "components/Dialog";

const LoadingScreen = ({ loading }) => {
  return <AlertDialog open={loading} title={<CircularProgress />} />;
};

export default LoadingScreen;
